import React from "react";

interface CloseCrossIconProps {
    color: string;
}

export const CloseCrossIcon = ({ color }: CloseCrossIconProps) => (
    <div>
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L5 5M9 9L5 5M5 5L9 1M5 5L1 9" stroke={color} />
        </svg>
    </div>
);
